import React, { useState } from "react";
import "./styles.css";
import CircularProgress from "@mui/material/CircularProgress";

const ButtonWithIcon = ({
  onClick,
  isLoading,
  style,
  children,
  disabled,
  icon,
  iconStyle,
}) => {
  const [isButtonClicked, setIsButtonClicked] = useState(false);

  const handleClick = () => {
    setIsButtonClicked(true);
    onClick();
    setTimeout(() => {
      setIsButtonClicked(false);
    }, 500);
  };

  return (
    <button
      disabled={disabled || isLoading}
      type="button"
      className={`icon-button ${isButtonClicked && "button-clicked"}`}
      onClick={handleClick}
      style={style}
    >
      {isLoading ? (
        <CircularProgress size={25} style={{ color: "white" }} />
      ) : (
        <>
          <img src={icon} alt="" className="icon" style={iconStyle} />
          {children}
        </>
      )}
    </button>
  );
};

export default ButtonWithIcon;
